module.exports = __webpack_public_path__ + "img/mp_tips.d3e5ea52.png";